import { graphql, HttpResponse } from 'msw';
import type { FixPreviewItemSelectMutation, FixPreviewItemSelectMutationVariables } from '../graphql/fixPreviewItemSelect';
import type { FixPreviewItemRejectMutation, FixPreviewItemRejectMutationVariables } from '../graphql/fixPreviewItemReject';
import type { FixPreviewItemRejectionReasonSaveMutation, FixPreviewItemRejectionReasonSaveMutationVariables } from '../graphql/fixPreviewItemRejectionReasonSave';
const stitchfix = graphql.link(process.env.NEXT_PUBLIC_GRAPHQL_API_ENDPOINT || 'https://www.stitchfix.com/graphql-api/api/graphql');
const buildFixPreviewItemMutationSuccessResult = (input: {
  fixPreviewItemId: string;
  skuId?: string | null;
  selected?: boolean | null;
  rejectionReason?: string | null;
}) => ({
  __typename: 'FixPreviewItemMutationSuccess' as const,
  toastMessage: null,
  itemDecisionState: {
    __typename: 'FixPreviewItemDecisionState' as const,
    fixPreviewItemId: input.fixPreviewItemId,
    skuId: input.skuId ?? null,
    selected: input.selected ?? null,
    rejectionReason: input.rejectionReason ?? null
  }
});
export const fixPreviewItemSelect = stitchfix.mutation<FixPreviewItemSelectMutation, FixPreviewItemSelectMutationVariables>('fixPreviewItemSelect', ({
  variables
}) => {
  const {
    fixPreviewItemId
  } = variables.input;
  return HttpResponse.json({
    data: {
      fixPreviewItemSelect: {
        __typename: 'FixPreviewItemSelectPayload',
        result: buildFixPreviewItemMutationSuccessResult({
          fixPreviewItemId,
          selected: true
        })
      }
    }
  });
});
export const fixPreviewItemReject = stitchfix.mutation<FixPreviewItemRejectMutation, FixPreviewItemRejectMutationVariables>('fixPreviewItemReject', ({
  variables
}) => {
  const {
    fixPreviewItemId
  } = variables.input;
  return HttpResponse.json({
    data: {
      fixPreviewItemReject: {
        __typename: 'FixPreviewItemRejectPayload',
        result: buildFixPreviewItemMutationSuccessResult({
          fixPreviewItemId,
          selected: false
        })
      }
    }
  });
});
export const fixPreviewItemRejectionReasonSave = stitchfix.mutation<FixPreviewItemRejectionReasonSaveMutation, FixPreviewItemRejectionReasonSaveMutationVariables>('fixPreviewItemRejectionReasonSave', ({
  variables
}) => {
  const {
    fixPreviewItemId,
    rejectionReasonValue
  } = variables.input;
  return HttpResponse.json({
    data: {
      fixPreviewItemRejectionReasonSave: {
        __typename: 'FixPreviewItemRejectionReasonSavePayload',
        result: buildFixPreviewItemMutationSuccessResult({
          fixPreviewItemId,
          selected: false,
          rejectionReason: rejectionReasonValue
        })
      }
    }
  });
});
export const fixPreviewHandlers = [fixPreviewItemSelect, fixPreviewItemReject, fixPreviewItemRejectionReasonSave];